import * as React from "react";
import CommissionConfigForm from "./CommissionConfigForm";
import Modal from "../core/Modal";
import * as moment from "moment";

interface IProps {
  open: boolean;
  close: () => void;
  config: ICommissionConfig;
  showVersionInfo?: boolean;
}

function CommissionConfigViewModal({
  open,
  close,
  config,
  showVersionInfo = false,
}: IProps) {
  return (
    <Modal
      title={"Current Commission Configuration"}
      open={open}
      isLarge={true}
      submittable={false}
      close={close}
    >
      {showVersionInfo && (
        <>
          <p>
            This is a display of the {config.archived ? "(now archived)" : ""}{" "}
            configuration '{config.name}' from{" "}
            {moment(config.updatedAt).format("llll")}
          </p>
          <hr />
        </>
      )}
      {config && <CommissionConfigForm config={config} readOnly={true} />}
    </Modal>
  );
}

export default CommissionConfigViewModal;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionConfigViewModal.tsx